import { AllTokens, PersonEmailFragment } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";

export function PersonEmail({ data }: { data: PersonEmailFragment }) {
  return (
    <Guard.HiddenLabel.IfCantRead
      influencedBy={[AllTokens.EmployeesProfileEmail]}
    >
      <span>{data.email}</span>
    </Guard.HiddenLabel.IfCantRead>
  );
}
